module.exports = __webpack_public_path__ + "static/media/search_location.041a6467.svg";